import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

//components
import PrivateRoute from "./components/PrivateRoute";
import AlertBar from "./components/AlertBar";
import BackdropLoader from "./components/BackdropLoader";

const LoginView = React.lazy(() => import("./pages/auth/login"));
const MainView = React.lazy(() => import("./pages"));
const ViewLogSummary = React.lazy(() => import("./pages/app/log_summary"));

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<LoginView />} />
        <Route element={<PrivateRoute />}>
          <Route path="/" element={<MainView />} />
          <Route path="log_summary" element={<ViewLogSummary />} />
        </Route>
      </Routes>
      <AlertBar />
      <BackdropLoader />
    </Router>
  );
}

export default App;
